import React from 'react';

const LEGEND_ITEMS = [
  { color: '#7F1D1D', label: '₱5M+', range: 'Exceptional' },
  { color: '#DC2626', label: '₱3M–5M', range: 'High' },
  { color: '#EF4444', label: '₱1M–3M', range: 'Good' },
  { color: '#D4AF37', label: '₱500K–1M', range: 'Moderate' },
  { color: '#8B92A5', label: '₱100K–500K', range: 'Low' },
  { color: '#2A2E3A', label: '<₱100K', range: 'Minimal' },
];

export default function MapLegend({ activeMetric }) {
  const metricLabels = {
    revenue: 'Revenue (PHP)',
    volume: 'Volume (Units)',
    accounts: 'Account Density',
  };

  return (
    <div className="border border-border rounded-lg p-3 shadow-sm" style={{ background: 'var(--color-card)' }}>
      <p className="font-caption text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2">
        {metricLabels?.[activeMetric] || 'Revenue (PHP)'}
      </p>
      <div className="flex flex-col gap-1.5">
        {LEGEND_ITEMS?.map((item) => (
          <div key={item?.label} className="flex items-center gap-2">
            <div
              className="w-4 h-3 rounded-sm flex-shrink-0"
              style={{ backgroundColor: item?.color, border: '1px solid rgba(255,255,255,0.1)' }}
            />
            <span className="font-data text-xs text-foreground whitespace-nowrap">{item?.label}</span>
            <span className="font-caption text-xs text-muted-foreground hidden sm:inline">— {item?.range}</span>
          </div>
        ))}
      </div>
    </div>
  );
}